import { useEffect, useMemo, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ClearanceLevelID } from "userful-chronos-app-common-js/dist/models/common";
import { ClearanceLevel } from "userful-chronos-app-common-js/dist/models/usermgt/clearanceLevel";
import { useUsermgtSelector } from "userful-chronos-common-store/dist/usermgt";
import { getLevelTabledata } from "./source/SourceFormUtil";
import SourcePermissionTable from "./SourcePermissionTable";
interface IProps {
    mustHave?: ClearanceLevelID[];
    data: ClearanceLevelID[];
    onChange: Function;
    hideHeader?: boolean;
    noMarginTop?: boolean;
    isSourceOrDestination?: boolean;
    disableAll?: boolean;
}

const SourcePermissionsForm = (props: IProps) => {
    const { t } = useTranslation();
    // this is list of all the clearance levels
    const levelData: ClearanceLevel[] =
        useUsermgtSelector((state) =>
            props.isSourceOrDestination
                ? state.levelStore.clearanceLevelsThatUserHasAccess
                : state.levelStore.filteredClearanceLevels,
        ) || [];
    // getLevelTableData reads through the list of all clearance levels and creates a table with clearance level name and then
    // also finds the edit and execute and see if it will be checked orunchecked
    const tableDataRef = useRef(getLevelTabledata(levelData, props.data || []));
    const [tableData, setTableData] = useState(getLevelTabledata(levelData, props.data || []));

    const mustHaveIds = props.mustHave ?? [];
    const mustHaveIdSet = useMemo(() => {
        return new Set(mustHaveIds.map((id) => id.value));
    }, [mustHaveIds]);

    useEffect(() => {
        tableDataRef.current = getLevelTabledata(levelData, props.data || []);
        setTableData(getLevelTabledata(levelData, props.data || []));
    }, [levelData, props.data]);

    useEffect(() => {
        const data = props.data || [];
        mustHaveIdSet.forEach((id) => {
            const alreadyHas = data.some((item) => item?.value === id);
            if (!alreadyHas) {
                props.onChange?.(true, id);
            }
        });
    }, [mustHaveIdSet, props.data, props.onChange]);

    return (
        <>
            {!props.hideHeader && (
                <Form.Group
                    className="input-wrapper"
                    controlId="permissionSelection"
                    style={{ marginTop: `${props.noMarginTop ? "" : "36px"}` }}
                >
                    <div>
                        <div className="info-heading">{t("Shared.UserPermissions")}</div>
                        <span className="heading2">{t("Shared.UserPermissionsDes")}</span>
                    </div>
                </Form.Group>
            )}
            <SourcePermissionTable
                data={tableData}
                disabledIds={mustHaveIdSet}
                onChange={(checkBool, value) => {
                    if (!checkBool && mustHaveIdSet.has(value)) {
                        return;
                    }
                    props.onChange?.(checkBool, value);
                }}
                disableAll={props.disableAll}
            />
        </>
    );
};

export default SourcePermissionsForm;
